<script setup lang="ts">
import type { Component } from 'vue'

/**
 * Dispatches the tenant's configured hero background animation. Renders
 * nothing for 'none' (or any unknown key); every animation is decorative
 * (aria-hidden) and sits absolutely behind the hero content.
 *
 * The `animation` prop is a plain string so the layer stays decoupled from
 * any single app's SiteHeroAnimation union — apps pass their own typed value,
 * which is assignable to string.
 */
import ParticlesBg from './ParticlesBg.vue'
import OrbitRingsBg from './OrbitRingsBg.vue'
import AuroraBg from './AuroraBg.vue'
import DotGridBg from './DotGridBg.vue'
import ShootingStarsBg from './ShootingStarsBg.vue'

const props = defineProps<{ animation: string }>()

const components: Record<string, Component> = {
  particles: ParticlesBg,
  orbit_rings: OrbitRingsBg,
  aurora: AuroraBg,
  dot_grid: DotGridBg,
  shooting_stars: ShootingStarsBg
}

const active = computed(() => components[props.animation] ?? null)
</script>

<template>
  <component
    :is="active"
    v-if="active"
  />
</template>
